import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-doer-provide-service-card__base-info" }
const _hoisted_2 = { class: "c-doer-provide-service-card__col-left" }
const _hoisted_3 = { class: "c-doer-provide-service-card__col-right" }
const _hoisted_4 = { class: "c-doer-provide-service-card__base-info-header" }
const _hoisted_5 = { class: "c-doer-provide-service-card__time" }
const _hoisted_6 = { class: "c-doer-provide-service-card__base-info-footer" }
const _hoisted_7 = { class: "c-doer-provide-service-card__extend-info" }
const _hoisted_8 = { class: "c-doer-provide-service-card__item --align-end" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-doer-provide-service-card__item-label" }, " Зарплата ", -1)
const _hoisted_10 = { class: "c-doer-provide-service-card__item-value" }
const _hoisted_11 = { class: "c-doer-provide-service-card__price c-doer-provide-service-card__price--green" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_c_image_bg = _resolveComponent("c-image-bg")!
  const _component_car_number = _resolveComponent("car-number")!
  const _component_c_currency = _resolveComponent("c-currency")!
  const _component_visit_group_provide_service_item = _resolveComponent("visit-group-provide-service-item")!
  const _component_collapse_transition = _resolveComponent("collapse-transition")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: _normalizeClass({
    'c-doer-provide-service-card': true,
    'c-doer-provide-service-card--expanded': _ctx.expanded,
  })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_button, {
        class: "c-doer-provide-service-card__spoiler-btn",
        fill: "clear",
        onClick: _ctx.toogleExpand
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { name: "core-collapse-arrow" })
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_c_image_bg, {
            ratio: 0.68,
            src: _ctx.groupInfo.addrImage || _ctx.carNoPhoto
          }, null, 8, ["ratio", "src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.datetimeFormatted), 1),
            _createVNode(_component_car_number, {
              "car-number": _ctx.groupInfo.carNumber
            }, null, 8, ["car-number"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("span", { class: "c-doer-provide-service-card__category" }, _toDisplayString(_ctx.groupInfo.nameCategory), 513), [
              [_vShow, _ctx.expanded]
            ]),
            _createVNode(_component_c_currency, {
              price: _ctx.groupInfo.payed
            }, {
              default: _withCtx(({ priceFormatted }) => [
                _withDirectives(_createElementVNode("span", { class: "c-doer-provide-service-card__price" }, _toDisplayString(priceFormatted), 513), [
                  [_vShow, !_ctx.expanded]
                ])
              ]),
              _: 1
            }, 8, ["price"])
          ])
        ])
      ]),
      _createVNode(_component_collapse_transition, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupInfo.provideServicesInformation, (provideInformation) => {
              return (_openBlock(), _createBlock(_component_visit_group_provide_service_item, {
                key: provideInformation.providedId,
                info: provideInformation
              }, null, 8, ["info"]))
            }), 128)),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_c_currency, {
                  price: _ctx.groupInfo.totalReward
                }, {
                  default: _withCtx(({ priceFormatted }) => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(priceFormatted), 1)
                  ]),
                  _: 1
                }, 8, ["price"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.expanded]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}